export async function enableMocking() {
  const isDemoOrDev = ['demo', 'development'].includes(process.env.ENV || '');

  if (isDemoOrDev) {
    const { worker } = await import('./browser');
    return worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: {
        url: '/mockServiceWorker.js',
      },
      quiet: false,
    });
  }

  return;
}
